import { TableCell, TableRow } from "@mui/material";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { useNavigate } from "react-router-dom";


const PartOffersTableRow = ({
    partOffer,
}) => {
    const navigate = useNavigate();

    const getFullName = () => {
        return `${partOffer.User.firstname} ${partOffer.User.lastname}`;
    };

    const getLocation = () => {
        const city = partOffer.city || "";
        return city;
    };

    const getGuranteeString = () => {
        return partOffer.guarantee ? "Da" : "Ne";
    };

    const getPriceString = () => {
        return `${partOffer.price} ${partOffer.currency.toUpperCase()}`;
    };

    const handleRedirect = () => {
        const breadcrumbs = [
            { title: "Pocetak", href: "/home" },
            { title: partOffer.PartRequest.UserCar.title, href: `/garage/${partOffer.PartRequest.UserCar.user_car_id}` },
            { title: partOffer.PartRequest.title, href: `/part-request/${partOffer.part_request_id}` },
            { title: partOffer.title }
        ];

        const breadcrumbsQuery = encodeURIComponent(JSON.stringify(breadcrumbs));

        navigate(`/part-offer/${partOffer.part_offer_id}?breadcrumbs=${breadcrumbsQuery}`);
    };

    return (
        <TableRow
            onClick={() => handleRedirect()}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell>
                {getFullName()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {getLocation()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {partOffer.delivery}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {getGuranteeString()}
            </TableCell>

            <TableCell sx={{ ...styles.textStyle, textAlign: 'right' }}>
                {getPriceString()}
            </TableCell>

            <TableCell sx={styles.textStyle}>
                {partOffer.description}
            </TableCell>
        </TableRow>
    );
};


export default PartOffersTableRow;

const styles = {
    imageContainer: {
        width: 32,
        height: 32,
        borderRadius: 4
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: 4
    },
    textStyle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0,0,0,0.87)"
    }
};